import { glide as glide$1 } from '@motionone/generators';
import { createGeneratorEasing } from '../create-generator-easing.es.js';
const glide = createGeneratorEasing(glide$1);
export { glide };